import * as yup from "yup";
import { Validation } from "../../utils/Validation.utils";
export const DeletePriorityStatusInitialValues = {
    replacementStatusId: ""
};
export const DeletePriorityStatusSchema = yup.object().shape({
    replacementStatusId: yup.string().required(Validation.Required)
});
